import { PubSubService } from '../../services/Utils/PubSub/pubsub.service';

export class CampaignCancellationService {
  private static readonly CAMPAIGN_CANCELLATION_EVENT =
    'CAMPAIGN_OBJECTIVE_DATA_CANCELLATION';

  constructor(private pubSubService: PubSubService) {
    'ngInject';
  }

  /**
   * Triggers cancellation of all ongoing campaign objective data requests
   * This should be called when reactive-campaign-details onInit is triggered
   */
  triggerCancellation(): void {
    console.log(
      'CampaignCancellationService: Triggering cancellation of all campaign objective data requests'
    );
    this.pubSubService.publish(
      CampaignCancellationService.CAMPAIGN_CANCELLATION_EVENT
    );
  }

  /**
   * Subscribe to cancellation events
   * @param callback Function to call when cancellation is triggered
   * @returns Unsubscribe function
   */
  onCancellationTriggered(callback: () => void): () => void {
    return this.pubSubService.subscribe(
      CampaignCancellationService.CAMPAIGN_CANCELLATION_EVENT,
      callback
    );
  }
}
